import { Formik } from "formik";
import { Divider, Grid, TextField, FormLabel, Select, MenuItem, Autocomplete, Button } from "@mui/material";
import { useEffect, useState } from "react";
import CustomTable from "../../../../components/common/CustomTable/CustomTable";
import { useProductAttributeStore } from "../../../../hooks/useProductAttributeStore";
import { ModalFooter } from "../../../../components/common/Modal/ModalFooter";
import { CustomSnackbar } from "../../../../components/common/CustomSnackbar/CustomSnackbar";
import { useStoreStore } from "../../../../hooks/useStoreStore";

type Values = {
    id: number,
    idspecificattributes: number,
}

const columns = [
    { type: 'options', field: 'options', label: 'Acciones', align:'center' },
    { type: 'text', field: 'name', label: 'Bodega', align:'center' },
    { type: 'text', field: 'stock', label: 'Stock', align:'center' },
];

const bodegas = [
    {id: 1, name: 'demo', stock:100},
    {id: 2, name: 'laudus', stock:100},
]

const filter = [
    {id: 1, stock:100},
]

export const SectionWarehouses: React.FC<any> = (props): JSX.Element | any => {

    const { dataWarehouse, setDataWarehouse, currentSection, handlePrevSection, handleNextSection, sections, clearState } = props;

    const { getStore } = useStoreStore();

    const [loadingdata, setLoadingdata] = useState<boolean>(false);
    const [loadingtable, setLoadingtable] = useState<boolean>(false);
    const [warehouses, setWarehouses] = useState<any>([]);
    const [warehouseselected, setwarehouseselected] = useState<any>('');
    const [stock, setstock] = useState<any>(1);

    const [dataSelected, setdataSelected] = useState<any>([]);

    useEffect(() => {
        getStoreApi();
    },[]);

    useEffect(() => {
        // setdataSelected(bodegas);
    },[]);

    useEffect(() => {
        if(dataWarehouse.idwarehouses && warehouses){
            setCustomWarehouses(dataWarehouse.idwarehouses, warehouses)
        }
    },[dataWarehouse.idwarehouses, warehouses])

    const setCustomWarehouses = (idwarehouses, warehouses) => {
        const idwarehouseArray = idwarehouses || [];
        const data = warehouses.filter(warehouse => idwarehouseArray.some(item => item.id === warehouse.id));
        const formattedData = data.map(warehouse => ({ id: warehouse.id, name: warehouse.name, stock: findStockById(warehouse.id, idwarehouseArray) }));

        return setdataSelected(formattedData || []);
    }
    const findStockById = (id, idwarehouseArray) => {
        const warehouse = idwarehouseArray.find(warehouse => warehouse.id === id);
        return warehouse ? warehouse.stock : 0;
    }

    const getStoreApi = async(search='') => {
        try {
            setLoadingdata(true);
            const response = await getStore(search);
            if(!response){
                setWarehouses([]); setLoadingdata(false);
                return false;
            }else{
                setWarehouses(response || []); setLoadingdata(false);
            }
        } catch (error) {
            setLoadingdata(false);
        }
    }

    const handleKeyDown = (event) => {
        const keyCode = event.keyCode || event.which;
        if (keyCode === 189 || keyCode === 109) {
          event.preventDefault();
        }
    };

    const validateForm = (values) => {
        let errors:any = {};
        return errors;
    }

    const onDelete = (rowSelected:any) => {
        const attributes = dataSelected.filter(attribute => attribute.id !== rowSelected.id)
        setdataSelected([...attributes])
    }

    const addAttribute = () => {
        if(!warehouseselected) return CustomSnackbar('error', "Seleccione una bodega");

        const isIdAlreadyExists = dataSelected.some(item => item.id === warehouseselected.id);
        if (isIdAlreadyExists) return CustomSnackbar('error', "La bodega ya se encuentra seleccionada");

        setdataSelected([...dataSelected, {id:warehouseselected.id, name: warehouseselected.name, stock:stock}]);
        setwarehouseselected('');
        setstock(1);
    }

    const onSubmit = async(values)  => {
        // if(dataSelected.length == 0) return CustomSnackbar('error', "Seleccione almenos una bodega");
        if(dataSelected.length > 0) {
            const datafilter = dataSelected.map(warehouse => ({ id: warehouse.id, stock: warehouse.stock }));
            setDataWarehouse({...values, idwarehouses: datafilter})
        }
        handleNextSection && handleNextSection();
    }

    const onCancel = () => {
        handlePrevSection && handlePrevSection();
    }

    return (
        <Grid sx={{height:'100%', position: 'relative'}}>
            <Formik initialValues={dataWarehouse} enableReinitialize validate={ (values) => validateForm(values) } onSubmit={onSubmit}>
                {({values, errors, touched, handleSubmit, handleChange, setFieldValue}) => {
                    return (
                        <form onSubmit={handleSubmit}>
                            <Grid container sx={{maxHeight: '65vh', overflowY: 'scroll', paddingRight:'5px'}}>
                                <Grid item container xs={12} spacing={2}>
                                    <Grid item xs={12} md={6}>
                                        <FormLabel>Bodegas:</FormLabel>
                                        <Autocomplete
                                            id="idwarehouse"
                                            size="small"
                                            value={!!warehouseselected ? warehouseselected : null}
                                            options={warehouses || []}
                                            loading={loadingdata}
                                            getOptionLabel={(departament) => departament?.name || ''}
                                            isOptionEqualToValue={(option,value)=> option.name === value?.name} 
                                            renderInput={(params) => 
                                                <TextField {...params} label="" size="small"
                                                    error={errors.idwarehouse && touched.idwarehouse ? true : false}
                                                />
                                            }
                                            onChange={(e, newValue: any) => {
                                                setwarehouseselected(newValue)
                                                setFieldValue('idwarehouse', newValue ? newValue.id : "");
                                            }}
                                        />
                                    </Grid>
                                    <Grid item xs={12} md={6}>
                                        <FormLabel>Stock:</FormLabel>
                                        <TextField
                                            id="stock"
                                            type="number" 
                                            name="stock"
                                            fullWidth
                                            size="small"
                                            value={stock}
                                            onChange={(e)=>{setstock(e.target.value)}}
                                            error={errors.stock && touched.stock ? true : false}
                                            onKeyDown={handleKeyDown}
                                            InputProps={{
                                                inputProps: {
                                                    min: 1
                                                }
                                            }}
                                        />
                                    </Grid>

                                    <Grid item xs={12}>
                                        <Grid item xs={12} display='flex' justifyContent='space-between' alignContent='center' alignItems='center'>
                                            <FormLabel>Listado de almacenes</FormLabel>
                                            <Button onClick={addAttribute}  size="small" variant="contained" className='btn-secondary'>
                                                {'Añadir'}
                                            </Button>
                                        </Grid>
                                        <CustomTable 
                                            disabled_title
                                            columns={columns} 
                                            loading={loadingtable}
                                            rows={dataSelected || []}
                                            onRowClick={() => {}}
                                            hasOptions
                                            onDelete={onDelete}
                                            RowsPerPage={3}
                                            dense
                                        />
                                    </Grid>
                                </Grid>
                            </Grid>
                            <div style={{ position: 'absolute', bottom: 0, width: '100%' }}>
                                <ModalFooter 
                                    buttonType="submit"
                                    confirmText={'Siguiente'}
                                    onConfirm={handleSubmit}
                                    cancelText={"Atrás"}
                                    onCancel={onCancel}
                                />
                            </div>
                        </form>
                    )
                }} 
            </Formik>
        </Grid>
    )
}